module.exports = __webpack_public_path__ + "static/media/flower.2f982dee.png";